var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"range-slider-container"},[_c('b-field',[_c('b-slider',{attrs:{"custom-formatter":(val) => val + '%',"tooltip":false,"indicator":"","rounded":"","max":150,"lazy":""},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }